import Logger from '@/Logger';

// Create instance of logger
const logger = new Logger('filtersStore', 'Actions');

export default {
  setFilters({ commit }, filterData) {
    // Remove null, undefined and empty strings
    const filters = Object.values(filterData.filters).filter(val => !!val);
    if (filters) {
      logger.info('Commiting filters to store', {
        [filterData.name]: filterData.filters,
      });

      commit('setFilters', {
        [filterData.name]: filterData.filters,
      });
    }
  },

  clearFilters({ commit }) {
    logger.info('Clearing filters from store.');
    commit('clearFilters');
  },
};
